import React from 'react';

const InteractiveSessions = () => {
    return (
        <div class="hero mt-20 mb-16 bg-slate-100 ">
        <div class="hero-content flex-col lg:flex-row mt-14 mb-16">
          <img src="https://i.ibb.co/F8DtGWq/Frame-29-1.png" class="admission" />
          <div>
          <div className='justify-center'>
                  <h1 class="text-start lg:ml-36 text-5xl font-medium text-primary text-3xl font-italic text-gold-600">Interactive Sessions<span className='text-secondary'>for Admission Help</span> </h1>
               
                  <p class="mt-12 text-lg text-justify lg:w-10/12 lg:ml-28">We are an official representative of institutes around the world to provide authentic services to students in Bangladesh. On this ground, we arrange regular seminars where prominent educational institutions take part and conduct informative sessions, followed by on-spot admission for potential candidates. This process breeds trust and confidence among the students and makes us a trustworthy student visa consultant in Bangladesh. Moreover, through interactive sessions, students get the golden opportunity to know about their dream institution and destination from QA sessions with institute representatives both in our onshore and offshore offices.</p>
               
                </div>
          </div>
        </div>
      </div>
    );
};

export default InteractiveSessions;